import React, { useEffect, useState } from "react";
import styles from '../index.module.css';
import viewStyles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { editOrder, getOrderById } from "../../../../redux/features/orders/ordersService";
import { useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { addNewInvoice, changeInvoiceStatus, editInvoice } from "../../../../redux/features/invoice/invoiceService";
import Invoice from "../../../../components/Receipts/Invoice";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import SimpleTableSkeleton from "../../../../components/SimpleTableSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleCheck, faMoneyBill, faPlusCircle, faUpload, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import PdfIcon from '../../../../assets/images/icons/pdf icon@3x.png';
import { editDocument } from "../../../../redux/features/document/documentService";
import Modal from "../../../../components/Modal";
import TableSkeleton from "../../../../components/Skeleton";
import NoResultsFound from "../../../../components/NoResultsFound";

const statusColors = {
    'Pending': '#FACC15',
    'Order Created': '#38BDF8',
    'Order Changed': '#14B8A6',
    'Order Confirmed': '#34D399',
    'Quotation Created': '#60A5FA',
    'Quotation Changed': '#22D3EE',
    'Quotation Sent': '#6366F1',
    'Order Cancelled': '#EF4444',
    'Order Refunded': '#FB7185',
    'Order Shipped': '#8B5CF6',
    'Order Completed': '#10B981',
};

const paymentStatusColors = {
    'Pending': '#FACC15',
    'Invoice Sent': '#38BDF8',
    'Order Changed': '#14B8A6',
    'Order Confirmed': '#34D399',
    'Quotation Created': '#60A5FA',
    'Quotation Changed': '#22D3EE',
    'Quotation Sent': '#6366F1',
    'Order Cancelled': '#EF4444',
    'Order Refunded': '#FB7185',
    'Order Shipped': '#8B5CF6',
    'Payment Approved': '#10B981',
};

const formattedAmount = (amount) =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);

const ViewOrder = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isInvoiceCreating } = useSelector((state) => state.invoice.newInvoice);
    const { isOrderLoading, order } = useSelector((state) => state.order.orderDetails);
    const { isEditingInvoice } = useSelector((state) => state.invoice.editedInvoice);
    const { isStatusLoading } = useSelector((state) => state.invoice.changeStatus);

    const [formData, setFormData] = useState({});

    const [errorMessages, setErrorMessages] = useState({});
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);
    const [billNumber, setBillNumber] = useState(null);
    const [bookingNumber, setBookingNumber] = useState(null);
    let cumulativeSellingPrice = 0;

    const getOrderData = async () => {
        try {
            const response = await dispatch(getOrderById({ id })).unwrap();
            if (response.status === 'Order Cancelled') {
                navigate('/admin/orders')
            }
            setFormData({
                bill_to_name: response?.bill_to_name,
                address_line_1: response?.address_line_1,
                address_line_2: response?.address_line_2,
                city: response?.city,
                details_line_1: response?.details_line_1,
                details_line_2: response?.details_line_2,
                details_line_3: response?.details_line_3,
            });
            setBillNumber(response?.bl_number);
            setBookingNumber(response?.booking_number);
        } catch (error) {
            showToast('error', error.message);
        }
    }

    useEffect(() => {
        getOrderData();
    }, [dispatch, id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    // Validate input
    const isValidQuotation = () => {
        const errors = {};
        if (!formData.address_line_1) {
            errors.address_line_1 = "Address line one is required.";
        }
        if (!formData.address_line_2) {
            errors.address_line_2 = "Address line two is required.";
        }
        if (!formData.city) {
            errors.city = "City is required.";
        }
        if (!formData.quotation_date) {
            errors.quotation_date = "Date is required.";
        }
        if (!formData.invoice_type) {
            errors.invoice_type = "Invoice Type is required.";
        }
        if (!formData.total_price_type) {
            errors.total_price_type = "Price type is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const data = {
        order_id: 1,
        bill_to_name: 'Nimal Perera',
        bill_to_address: 'No 12, Main Road',
        quotation_date: '2025-05-24',
        valid_until: '2025-06-24',
        notes: '',
        quotation_status: "Quotation_Created"
    }

    const generateInvoice = async (data) => {
        try {
            const pdfBlob = await pdf(<Invoice data={[data, order]} />).toBlob();
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, "_blank");
        } catch (error) {
            showToast('error', error.message);
        }
    }
    const submitQuotation = async () => {
        if (isValidQuotation()) {
            const data = {
                order_id: +id,
                bill_to_name: order?.customer.full_name,
                address_line_1: formData.address_line_1,
                address_line_2: formData.address_line_2,
                city: formData.city,
                details_line_1: formData.details_line_1,
                details_line_2: formData.details_line_2,
                details_line_3: formData.details_line_3,
                invoice_date: formData.quotation_date,
                notes: formData.notes && formData.notes,
                total_price_type: formData.total_price_type,
                invoice_type: formData.invoice_type,
                invoice_status: "Invoice Created"
            }
            try {
                const response = await dispatch(addNewInvoice(data)).unwrap();
                showToast('success', response.message);
                dispatch(getOrderById({ id }));
                await generateInvoice(data);
            }
            catch (error) {
                showToast('error', error.message);
            };
        }
    }

    const updateQuotation = async () => {
        if (isValidQuotation()) {
            const invoiceData = {
                id: +order?.quotations[0].id,
                bill_to_name: order?.customer.full_name,
                address_line_1: formData.address_line_1,
                address_line_2: formData.address_line_2,
                city: formData.city,
                quotation_date: formData.quotation_date,
                valid_until: formData.valid_until,
                notes: formData.notes && formData.notes
            }
            const data = {
                id: +order?.quotations[0].id,
            }
            if (formData.address_line_1 !== order?.quotations[0].address_line_1) {
                data.address_line_1 = formData.address_line_1;
            }
            if (formData.address_line_2 !== order?.quotations[0].address_line_2) {
                data.address_line_2 = formData.address_line_2;
            }
            if (formData.city !== order?.quotations[0].city) {
                data.city = formData.city;
            }
            if (formData.quotation_date !== order?.quotations[0].quotation_date) {
                data.quotation_date = formData.quotation_date;
            }
            if (formData.valid_until !== order?.quotations[0].valid_until) {
                data.valid_until = formData.valid_until;
            }
            if (formData.notes !== order?.quotations[0].notes) {
                data.notes = formData.notes;
            }

            if (Object.keys(data).length === 1) {
                showToast('error', 'No updates were made as the quotation details remain unchanged.');
                return;
            }
            try {
                const response = await dispatch(editInvoice(data)).unwrap();
                showToast('success', response.message);
                dispatch(getOrderById({ id }));
                await generateInvoice(invoiceData);
            }
            catch (error) {
                showToast('error', error.message);
            };
        }
    }

    const updateQuotationStatus = async (quotation) => {
        try {
            const data = {
                id: +quotation.id,
                quotation_status: "Quotation Sent"
            }
            const response = await dispatch(changeInvoiceStatus(data)).unwrap();
            showToast('success', response.message);
            dispatch(getOrderById({ id }));
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const documentUpload = () => navigate(`/admin/orders/${id}/document`);

    const handleCancelYes = async () => {
        setCancelModalOpen(false);
        try {
            const data = {
                id: +selectedDocument.id,
                status: false
            }
            const response = await dispatch(editDocument(data)).unwrap();
            showToast('success', response.message);
            setSelectedDocument(null);
        }
        catch (error) {
            setSelectedDocument(null);
            showToast('error', error.message);
        };
    }

    const closeCancelModal = () => setCancelModalOpen(false);

    const viewDocument = (document) => {
        window.open(document.document_url, "_blank");
    }

    const openDocument = async (payment) => {
        window.open(payment.document_url, "_blank");
    }
    const viewPayment = (payment) => navigate(`/admin/orders/${id}/${payment.id}`);

    const submitBillNumber = async () => {
        try {
            const data = {
                id: +id,
                bl_number: billNumber
            }
            const response = await dispatch(editOrder(data)).unwrap();
            if (response.success === true) {
                showToast('success', response.message);
            }
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const submitBookingNumber = async () => {
        try {
            const data = {
                id: +id,
                booking_number: bookingNumber
            }
            const response = await dispatch(editOrder(data)).unwrap();
            if (response.success === true) {
                showToast('success', response.message);
            }
        } catch (error) {
            showToast('error', error.message);
        }
    }

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Order Details</h1>
                <div className={styles.formContainer}>
                    <div className={viewStyles.orderDetailsDiv}>
                        <div className={viewStyles.customerDetails}>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Customer Code: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.customer_code}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Name: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.full_name}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Phone Number: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.phone_number}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Email: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.customer.email}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Agent: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.agent.full_name}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Phone Number: </p>
                                <p className={viewStyles.valueSec}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.agent.phone_number}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Order Status: </p>
                                <p className={`${viewStyles.valueSec} ${viewStyles.statusLabel}`} style={{ backgroundColor: statusColors[order?.status] }}>{isOrderLoading ? <Skeleton inline width={100} /> : order?.status}</p>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Bill Number
                                        </label>
                                        {isOrderLoading ? <Skeleton inline width={100} /> :
                                            <div className={viewStyles.inputSingleRow}>
                                                <input
                                                    type="text"
                                                    id="bl_number"
                                                    name="bl_number"
                                                    value={billNumber || ''}
                                                    className={`form-input-default ${viewStyles.payInput}`}
                                                    placeholder="Enter number"
                                                    onChange={(e) => setBillNumber(e.target.value)} />
                                                <button type="button" className={viewStyles.checkBtn} onClick={submitBillNumber}><FontAwesomeIcon icon={faCheck} size="xl" /></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Booking Number
                                        </label>
                                        {isOrderLoading ? <Skeleton inline width={100} /> :
                                            <div className={viewStyles.inputSingleRow}>
                                                <input
                                                    type="text"
                                                    id="booking_number"
                                                    name="booking_number"
                                                    value={bookingNumber || ''}
                                                    className={`form-input-default ${viewStyles.payInput}`}
                                                    placeholder="Enter number"
                                                    onChange={(e) => setBookingNumber(e.target.value)} />
                                                <button type="button" className={viewStyles.checkBtn} onClick={submitBookingNumber}><FontAwesomeIcon icon={faCheck} size="xl" /></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={viewStyles.vehicleDetails}>
                            <label className={viewStyles.subTitle}>Vehicles</label>
                            <div className={`table-container`}>
                                {isOrderLoading ?
                                    <SimpleTableSkeleton columns={["Stock No", "Image", "Vehicle", "Year", "Chassis", "Lot NM", "Auction House", "Buying Price",
                                        "Auction Fee", "Local Transport", "EC Cost", "Repairing Cost", "FOB Cost", "Freight", "CNF Cost", "J and A Charge", "Selling Price", "Total"
                                    ]} rowCount={2} height={20} />
                                    :
                                    <table className={styles.table}>
                                        <thead className={styles.thead}>
                                            <tr>
                                                <th className={styles.theadD}>Stock No</th>
                                                <th className={styles.theadD}>Image</th>
                                                <th className={styles.theadD}>Vehicle</th>
                                                <th className={styles.theadD}>Year</th>
                                                <th className={styles.theadD}>Chassis</th>
                                                <th className={styles.theadD}>Lot NM</th>
                                                <th className={styles.theadD}>Auction House</th>
                                                <th className={styles.theadD}>Buying Price</th>
                                                <th className={styles.theadD}>Auction Fee</th>
                                                <th className={styles.theadD}>Local Transport</th>
                                                <th className={styles.theadD}>EC Cost</th>
                                                <th className={styles.theadD}>Repairing Cost</th>
                                                <th className={styles.theadD}>FOB Cost</th>
                                                <th className={styles.theadD}>Freight</th>
                                                <th className={styles.theadD}>CNF Cost</th>
                                                <th className={styles.theadD}>J and A Charge</th>
                                                <th className={styles.theadD}>Selling Price</th>
                                                <th className={styles.theadD}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody className={styles.tbody}>
                                            {order?.vehicles?.map((vehicle) => {
                                                const sellingPrice = vehicle.vehicle_costs[0]?.selling_price || 0;
                                                cumulativeSellingPrice += sellingPrice; // Add current selling_price to cumulative total

                                                return (
                                                    <tr key={vehicle.id}>
                                                        <td className={styles.tableCell}>{vehicle.stock_no}</td>
                                                        <td className={styles.tableCell}><img src={vehicle.image_url} alt="vehicle" className={viewStyles.vehicleImg} /></td>
                                                        <td className={styles.tableCell}>{vehicle.name}</td>
                                                        <td className={styles.tableCell}>{vehicle.reg_year}</td>
                                                        <td className={styles.tableCell}>{vehicle.chassis_no}</td>
                                                        <td className={styles.tableCell}>{vehicle.lot_nm}</td>
                                                        <td className={styles.tableCell}>{vehicle.auction_house}</td>

                                                        {/** Extract vehicle costs safely */}
                                                        {(() => {
                                                            const costs = vehicle.vehicle_costs[0] || {};
                                                            return (
                                                                <>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.buying_price)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.auction_fee)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.local_transport)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.ec_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.repairing_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.fob_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.freight)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.cnf_cost)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.j_and_a_charge)}</td>
                                                                    <td className={styles.tableCellValue}>{formattedAmount(costs.selling_price)}</td>

                                                                    {/** Display Cumulative Selling Price */}
                                                                    <td className={styles.tableCellValue}><strong>{formattedAmount(cumulativeSellingPrice)}</strong></td>
                                                                </>
                                                            );
                                                        })()}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-group`}>
                                <label className={viewStyles.subTitle}>
                                    Documents
                                </label>
                                <div className={`drop-input-full`} style={{ minHeight: '0' }}>
                                    <div className={viewStyles.imagePreviewContainer}>
                                        {order?.order_documents
                                            ?.filter((doc) => doc.status === true)
                                            .map((doc) => (
                                                <div key={doc.id} className={viewStyles.insertedFile}>
                                                    <div className={viewStyles.fileCard}>
                                                        <img src={PdfIcon} alt='File Type' className={viewStyles.leftIcon} onClick={() => viewDocument(doc)} />
                                                        <FontAwesomeIcon
                                                            icon={faXmarkCircle}
                                                            className={viewStyles.closeIcon}
                                                            onClick={() => {
                                                                setSelectedDocument(doc);
                                                                setCancelModalOpen(true);
                                                            }}
                                                        />
                                                        <a
                                                            href={doc?.document_url}
                                                            className={viewStyles.fileDownload}
                                                            onClick={(e) => e.stopPropagation()}
                                                            target="blank"
                                                        >
                                                            {doc?.name}
                                                        </a>
                                                    </div>
                                                </div>
                                            ))}

                                        <div className={viewStyles.fileCard} onClick={documentUpload} >
                                            <FontAwesomeIcon icon={faPlusCircle} size="2xl" className={viewStyles.plusIcon} />
                                        </div>
                                    </div>
                                </div>
                                {errorMessages.file && (
                                    <p className={`text-danger`}>{errorMessages.file}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-group`}>
                                <label className={viewStyles.subTitle}>
                                    Payments
                                </label>
                                {isOrderLoading ?
                                    <TableSkeleton columns={["Date", "Amount", "Currency", "Exchange Rate", "Status", "Action"]} rowCount={10} height={20} />
                                    : order?.payments.length > 0 ?
                                        <div className={`table-container`}>
                                            <table className={`table`}>
                                                <thead className={`thead`}>
                                                    <tr>
                                                        <th className={`theadColumnOne`}>Date</th>
                                                        <th>Amount</th>
                                                        <th>Currency</th>
                                                        <th>Exchange Rate</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className={`tbody`}>
                                                    {order?.payments?.map((payment) => (
                                                        <tr key={payment.id}>
                                                            <td className={`tdataColumnOne`}>
                                                                {payment.created_at.split('T')[0]}
                                                            </td>
                                                            <td>{formattedAmount(payment.amount)}</td>
                                                            <td>{payment?.currency}</td>
                                                            <td>{payment?.exchange_rate}</td>
                                                            <td>
                                                                <p style={{ backgroundColor: paymentStatusColors[payment?.payment_status] }}
                                                                    className={viewStyles.payemntStatusLabel}>{payment.payment_status}</p></td>
                                                            <td className={`actionsBtn`}>
                                                                {payment?.document_url !== '' &&
                                                                    <button className={`btn-edit-label`} onClick={() => openDocument(payment)}>
                                                                        <FontAwesomeIcon icon={faMoneyBill} />
                                                                    </button>
                                                                }
                                                                <button className={`btn-edit-label`} onClick={() => {
                                                                    viewPayment(payment)
                                                                }}>View</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <NoResultsFound />
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.vehicleFormGroup}>
                        <h1 className={`form-title`} style={{ marginTop: '20px' }}>Invoice</h1>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Billing Address Line 1<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='address_line_1'
                                            name='address_line_1'
                                            value={formData.address_line_1 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.address_line_1 && (
                                        <p className={`text-danger`}>{errorMessages.address_line_1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Billing Address Line 2<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='address_line_2'
                                            name='address_line_2'
                                            value={formData.address_line_2 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.address_line_2 && (
                                        <p className={`text-danger`}>{errorMessages.address_line_2}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            City<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='city'
                                            name='city'
                                            value={formData.city || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Address"
                                        />
                                    }
                                    {errorMessages.city && (
                                        <p className={`text-danger`}>{errorMessages.city}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 1
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_1'
                                            name='details_line_1'
                                            value={formData.details_line_1 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_1 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_1}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 2
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_2'
                                            name='details_line_2'
                                            value={formData.details_line_2 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_2 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_2}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Details Line 3
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='text'
                                            id='details_line_3'
                                            name='details_line_3'
                                            value={formData.details_line_3 || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                            placeholder="Enter Details"
                                        />
                                    }
                                    {errorMessages.details_line_3 && (
                                        <p className={`text-danger`}>{errorMessages.details_line_3}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Invoice Date<span className={`required-star`}>*</span>
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <input
                                            type='date'
                                            id='quotation_date'
                                            name='quotation_date'
                                            value={formData.quotation_date || ''}
                                            onChange={handleInputChange}
                                            className={`form-input-default`}
                                        />
                                    }
                                    {errorMessages.quotation_date && (
                                        <p className={`text-danger`}>{errorMessages.quotation_date}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col md-col`}>
                                <div className={`form-input-group`}>
                                    {isOrderLoading ? <Skeleton /> :
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Note
                                        </label>
                                    }
                                    {isOrderLoading ? <Skeleton /> :
                                        <textarea
                                            type='text'
                                            id='notes'
                                            name='notes'
                                            value={formData.notes || ''}
                                            onChange={handleInputChange}
                                            placeholder='Enter Note'
                                            className={`form-input-default`}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row ${viewStyles.radioRow}`}>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                Total Price Type
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='total_price_type' className={`form-label`}>
                                                <input type="radio" name="total_price_type" value="CNF" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            CNF
                                            <label htmlFor='total_price_type' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="total_price_type" value="FOB" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            FOB
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {errorMessages.total_price_type && (
                            <p className={`text-danger`} style={{ marginTop: '5px' }}>{errorMessages.total_price_type}</p>
                        )}
                        <div className={`form-input-row ${viewStyles.radioRow}`}>
                            <div className={`form-input-col md-col`}>
                                {isOrderLoading ? <Skeleton /> :
                                    <>
                                        <div className={`form-input-group ${viewStyles.radioLabel}`}>
                                            <label htmlFor='invoice_type' className={`form-label`}>
                                                Invoice Type
                                            </label>
                                        </div>
                                        <div className={viewStyles.radioValue}>
                                            <label htmlFor='invoice_type' className={`form-label`}>
                                                <input type="radio" name="invoice_type" value="Performa" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Performa
                                            <label htmlFor='invoice_type' className={`form-label`} style={{ marginLeft: '20px' }}>
                                                <input type="radio" name="invoice_type" value="Commercial" onChange={handleInputChange} className={viewStyles.customRadio} />
                                            </label>
                                            Commercial
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {errorMessages.invoice_type && (
                            <p className={`text-danger`} style={{ marginTop: '5px' }}>{errorMessages.invoice_type}</p>
                        )}
                        {
                            isOrderLoading ? <Skeleton /> :
                                <button
                                    className={`btn-primary`}
                                    type='button'
                                    disabled={isInvoiceCreating}
                                    onClick={submitQuotation}
                                    style={{ marginTop: '20px' }}
                                >
                                    {isInvoiceCreating ? <BeatLoader /> : `Create Invoice`}
                                </button>
                        }
                    </div>
                </div>
                {/* <PDFViewer width="100%" height="100%">
                    <Invoice  data={[data, order]} />
                </PDFViewer> */}
            </div>
            {isCancelModalOpen && (
                <Modal
                    title='Remove Document'
                    onClose={closeCancelModal}
                    onYes={handleCancelYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to remove the document?`}
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};

export default ViewOrder;
